import {
  useContext,
  createContext,
  ReactNode,
  useState,
  useCallback,
} from 'react';

import { useDragAndDrop } from '../components/shared/DragAndDrop/hook/dragAndDrop';

interface IColumnsProviderProps {
  children: ReactNode;
}

type Field = {
  id: string;
  name: string;
};

type ColumnsContextData = {
  fields: Field[];
  dropField: () => void;
  removeField: (value: Field) => void;
  clearFields: () => void;
};

const ColumnsContext = createContext({} as ColumnsContextData);

export function ColumnsProvider({ children }: IColumnsProviderProps) {
  const { field } = useDragAndDrop();
  const [fields, setFields] = useState<Field[]>([]);

  const dropField = useCallback(() => {
    const value = field;
    const hasFields = fields.filter(field => field.id === value.id).length > 0;
    if (!hasFields) {
      setFields(state => [...state, value]);
    }
  }, [fields, field]);

  const removeField = useCallback(
    (value: Field) => {
      const newFields = fields.filter(field => field.id !== value.id);
      setFields(newFields);
    },
    [fields],
  );

  // Remover tudo
  const clearFields = useCallback(() => {
    setFields(() => []);
  }, []);

  return (
    <ColumnsContext.Provider
      value={{ fields, dropField, removeField, clearFields }}
    >
      {children}
    </ColumnsContext.Provider>
  );
}

export const useColumns = () => useContext(ColumnsContext);
